import { createSelector } from "reselect"
import { map, pick } from "lodash"

const getPositionSets = (state, props) => props.positionSets
const getSelectedDate = (state, props) => props.selectedDate

export const getItems = createSelector(
  [getPositionSets, getSelectedDate],
  (positionSets, selectedDate) => map(positionSets, (ps, index) => ({
    id: String(index),
    disabled: ps.isUnmodeled,
    noData: ps.noData || selectedDate === ps.availableFrom,
    ...pick(ps, ["label", "color", "isUnmodeled"]),
  }),
  ),
)
